import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18dad52f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "About", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "CHI 2023", -1))
const _hoisted_3 = {
  target: "_blank",
  href: "https://doi.org/10.1145/3544548.3580693"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "IHM 2022", -1))
const _hoisted_5 = {
  target: "_blank",
  href: "https://doi.org/10.1145/3500866.3516371"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Papers using µGlyph:", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createTextVNode(" 3D Selection in Mixed Reality: Designing a Two-Phase Technique To Reduce Fatigue, "),
  /*#__PURE__*/_createElementVNode("i", null, "ISMAR 2023"),
  /*#__PURE__*/_createTextVNode(", "),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://doi.org/"
  }),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Adrien Chaffangeon Caillet, Alix Goguey and Laurence Nigay, To be published ")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "Mobile HCI 2023", -1))
const _hoisted_9 = {
  target: "_blank",
  href: "https://doi.org/10.1145/3604272"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Contact", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" To add your paper to our database, or if you have any question related to the notation, please e-mail us at:"),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "mailto:adrien.chaffangeon@univ-grenoble-alpes.fr" }, "adrien.chaffangeon@univ-grenoble-alpes.fr", -1))

export function render(_ctx, _cache) {
  const _component_unicon = _resolveComponent("unicon")

  return (_openBlock(), _createElementBlock("section", null, [
    _hoisted_1,
    _createElementVNode("p", null, [
      _createTextVNode(" µGlyph is a notation introduced by Adrien Chaffangeon Caillet, Alix Goguey and Laurence Nigay: "),
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _createTextVNode(" μGlyph: a Microgesture Notation, "),
          _hoisted_2,
          _createTextVNode(", "),
          _createElementVNode("a", _hoisted_3, [
            _createVNode(_component_unicon, {
              name: "external-link-alt",
              width: "17",
              height: "17"
            })
          ])
        ]),
        _createElementVNode("li", null, [
          _createTextVNode(" μGlyphe: une Notation Graphique pour Décrire les Microgestes, "),
          _hoisted_4,
          _createTextVNode(", "),
          _createElementVNode("a", _hoisted_5, [
            _createVNode(_component_unicon, {
              name: "external-link-alt",
              width: "17",
              height: "17"
            })
          ])
        ])
      ])
    ]),
    _hoisted_6,
    _createElementVNode("ul", null, [
      _hoisted_7,
      _createElementVNode("li", null, [
        _createTextVNode(" Studying the Visual Representation of Microgestures, "),
        _hoisted_8,
        _createTextVNode(", "),
        _createElementVNode("a", _hoisted_9, [
          _createVNode(_component_unicon, {
            name: "external-link-alt",
            width: "17",
            height: "17"
          })
        ]),
        _hoisted_10,
        _createTextVNode("Vincent Lambert, Adrien Chaffangeon Caillet, Alix Goguey, Sylvain Malacria and Laurence Nigay ")
      ])
    ]),
    _hoisted_11,
    _hoisted_12,
    _hoisted_13
  ]))
}